const baseStylinging = `bg-white text-black py-2
  border-x border-x-reix-blue border-y border-y-gray-300
  duration-300 checked:font-bold
  first:rounded-t-lg last:rounded-b-lg
  first:border-t-reix-blue last:border-b-reix-blue`;

export const ItemStyling = `${baseStylinging} hover:bg-indigo-200`;

export const DisabledItemStyling = `${baseStylinging} opacity-50 cursor-not-allowed`;
